import type { BadgeVariant } from '../../../components/ui/index.js';
import type { Memory } from '../../../generated/api/types.gen.js';

export type MemoryScope = Memory['scope'];

export const MEMORY_SCOPES: readonly MemoryScope[] = ['conversation', 'team', 'task', 'project', 'agent', 'org'];

export const MEMORY_SCOPE_LABEL: Record<MemoryScope, string> = {
  conversation: 'Conversation',
  team: 'Team',
  task: 'Task',
  project: 'Project',
  agent: 'Agent',
  org: 'Organization',
};

export const MEMORY_SCOPE_VARIANT: Record<MemoryScope, BadgeVariant> = {
  conversation: 'info',
  team: 'success',
  task: 'warning',
  project: 'neutral',
  agent: 'accent',
  org: 'purple',
};

/** Each scope can be promoted to a wider one. */
export const MEMORY_PROMOTION_TARGETS: Record<MemoryScope, readonly MemoryScope[]> = {
  conversation: ['task', 'project', 'agent', 'org'],
  team: ['project', 'org'],
  task: ['project', 'agent', 'org'],
  project: ['agent', 'org'],
  agent: ['org'],
  org: [],
};

export function formatRelativeTime(iso: string): string {
  const minutes = Math.floor((Date.now() - new Date(iso).getTime()) / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

/** `conversation_id` → `Conversation`. */
export function subjectLabel(subjectType: string): string {
  const base = subjectType.replace(/_id$/, '').replace(/_/g, ' ');
  return base.charAt(0).toUpperCase() + base.slice(1);
}
